try {
  module.exports = require('./prebuilt-tree.js');
} catch (e) {
  module.exports = require('./new-tree.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/which-country/lib/tree.js
// module id = 986
// module chunks = 0